import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';
import { Company } from '@app/_models/master/company';

@Injectable({
  providedIn: 'root'
})
export class CompanyService {
  
  constructor(private http: HttpClient) { }

  /**
   * Get all companies
   */
  getAll(): Observable<Company[]> {
    return this.http.get<Company[]>(`${environment.apiUrl}/Companies`);
  }

  /**
   * Get company by ID
   */
  getById(id: string): Observable<Company> {
    return this.http.get<Company>(`${environment.apiUrl}/Companies/${id}`);
  }

  /**
   * Add new company
   */
  add(company: Company): Observable<Company> {
    return this.http.post<Company>(`${environment.apiUrl}/Companies`, company);
  }

  /**
   * Update existing company
   */
  update(id: string, company: Company): Observable<Company> {
    return this.http.put<Company>(`${environment.apiUrl}/Companies/${id}`, company);
  }

  /**
   * Delete company
   */
  delete(id: string): Observable<any> {
    return this.http.delete(`${environment.apiUrl}/Companies/${id}`);
  }

  /**
   * Get active companies
   */
  getActive(): Observable<Company[]> {
    return this.http.get<Company[]>(`${environment.apiUrl}/Companies`);
  }

  /**
   * Set default company for user session
   */
  setDefaultCompany(companyId: string): Observable<any> {
    return this.http.post(`${environment.apiUrl}/Companies/set-default/${companyId}`, {});
  }

  /**
   * Get current user's default company
   */
  getDefaultCompany(): Observable<Company> {
    return this.http.get<Company>(`${environment.apiUrl}/Companies/default`);
  }
}
